import {requestOptions} from './base';

export const signinRequest = () => (
  requestOptions('adv/signin', {
    method: 'POST',
  })
);

export const signupRequest = () => (
  requestOptions('adv/signup', {
    method: 'POST',
  })
);
